import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { computed } from 'vue';
import SidebarItem from './SidebarItem';
import { useRouter, useRoute } from 'vue-router';
import { filterRouters, generateMenus } from '@/utils/route';
import { useStore } from 'vuex';
export default {
  __name: 'SidebarMenu',
  setup(__props) {
    const store = useStore();

    // 计算路由表结构
    const router = useRouter();
    const routes = computed(() => {
      var _store$getters$userIn, _store$getters$userIn2;
      const filterRoutes = filterRouters(router.getRoutes());
      const filterMenus = generateMenus(filterRoutes);
      console.log('🚀 ~ routes ~ filterMenus:', filterMenus);
      console.log((_store$getters$userIn = store.getters.userInfo) === null || _store$getters$userIn === void 0 ? void 0 : _store$getters$userIn.menus);
      return ((_store$getters$userIn2 = store.getters.userInfo) === null || _store$getters$userIn2 === void 0 ? void 0 : _store$getters$userIn2.menus) || [];
    });

    // 计算高亮 menu 的方法
    const route = useRoute();
    const activeMenu = computed(() => {
      const {
        meta,
        path
      } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    });
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": activeMenu.value,
        collapse: !_ctx.$store.getters.sidebarOpened,
        "background-color": _ctx.$store.getters.cssVar.menuBg,
        "text-color": _ctx.$store.getters.cssVar.menuText,
        "active-text-color": _ctx.$store.getters.cssVar.menuActiveText,
        "unique-opened": true,
        router: ""
      }, {
        default: _withCtx(() => [_createVNode(_unref(SidebarItem), {
          route: {
            remark: '首页',
            iconUrl: 'home',
            url: '/',
            childSysMenus: [],
            type: 1
          }
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, item => {
          return _openBlock(), _createBlock(_unref(SidebarItem), {
            key: item.id,
            route: item
          }, null, 8, ["route"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active", "collapse", "background-color", "text-color", "active-text-color"]);
    };
  }
};